import axios from 'axios'

export default new class TestMethodService {
  getList () {
    return axios.get('/test-methods')
  }
}()
